import { ITaskData, navigation, task } from '@origin-digital/reporting-client';
import * as React from 'react';
import { USERNAME } from 'ts/constants/UrlParams';
import { AccountFoundView } from './AccountFoundView';
import { getForgotPasswordUrl } from '../../../../login/services/urlService';
import { History } from 'history';
import { QuickLoginForm } from 'ts/login/components/QuickLogin/QuickLoginForm';
import { navigateToErrorPage } from '../error/ErrorNavigation';
import { ErrorFlow } from '../error/ErrorFlow';
import { useEffect } from 'react';
import { useAppContext } from '../../../../contexts/app/AppContext';

interface AccountFoundPageProps {
  history: History;
  location: Location;
}

const AccountFoundPage: React.FC<AccountFoundPageProps> = ({ history, location }) => {
  const { setShowLiveChatWidget } = useAppContext();
  const getEmail = () => new URLSearchParams(location.search).get(USERNAME);
  const forgotPasswordHref = `${getForgotPasswordUrl()}?${USERNAME}=${getEmail()}`;

  useEffect(() => {
    navigation('screen', {
      currentUri: '',
      friendlyUri: 'originenergy:my-account:auth:forgot-email-success',
    });

    task.base(
      'forgot-email' as any,
      {
        action: 'complete',
      } as ITaskData,
    );

    return () => {
      setShowLiveChatWidget(false);
    };
  }, []);

  return (
    <AccountFoundView email={getEmail()} forgotPasswordHref={forgotPasswordHref}>
      <QuickLoginForm
        setUsername={undefined}
        history={history}
        defaultRememberMe={true}
        location={location}
        username={getEmail()}
        // TODO might need annie for analytics in a later story placeholder for now
        errorPageFunction={(errorCode, errorFlowHistory) =>
          navigateToErrorPage(errorCode, ErrorFlow.forgotEmail, '', errorFlowHistory, true)
        }
      />
    </AccountFoundView>
  );
};

export { AccountFoundPage };
